document.addEventListener('DOMContentLoaded', function() {
  const selectionDetails = {
    "Select": {
      text: "",
      showOrderNumber: false
    },
    "Questions about my Online Order": {
      text: "To track your order, <a href='https://ellessene.aftership.com/?page-name=tracking-page' target='_blank'>click here</a>. If you still cannot find what you were looking for, please send us a message and our team will be happy to assist you.",
      showOrderNumber: true
    },
    "Product Information": {
      text: "Please visit our <a href='https://ellessene.com/pages/faq' target='_blank'>FAQ page</a> for answers to popular product-related queries. If you still cannot find what you were looking for, please send us a message and our team will be happy to assist you.",
      showOrderNumber: false
    },
    "Returns / Exchanges": {
      text: "Because ELLESSÈNE products are limited-run and hand-prepared to order, we do not currently accept returns or exchanges. In the rare case that an order arrives damaged or incorrect, please send us a message and our team will be happy to assist you.",
      showOrderNumber: true
    },
    "Cancel / change order": {
      text: "Please note, we are not able to cancel orders that have been prepared for shipping or already dispatched. Please send us your request as soon as possible, and our team will be happy to assist where possible.",
      showOrderNumber: true
    },
    "Corporate": {
      text: "Please include a summary of your event (and event date), desired products and quantities.",
      showOrderNumber: false
    },
    "Press Request": {
      text: "Please include the name of your media entity along with your message. Our team may send an ELLESSÈNE press package if requested.",
      showOrderNumber: false
    },
    "Other": {
      text: "",
      showOrderNumber: false
    }
  };

  const selectElement = document.querySelector('.contact-details');
  const selectionDetailsElement = document.querySelector('.selection-details');
  const orderNumberElement = document.querySelector('.order-number');

  selectElement.addEventListener('change', function() {
    const selectedValue = selectElement.value;
    const details = selectionDetails[selectedValue];

    if (details) {
      selectionDetailsElement.innerHTML = details.text;

      if (details.showOrderNumber) {
        orderNumberElement.classList.remove('hidden');
        orderNumberElement.querySelectorAll("input").forEach((el)=>{
          el.addAttribute("required")
        })
        orderNumberElement.querySelector('input').name = "contact[order number]";
      } else {
        orderNumberElement.classList.add('hidden');
        orderNumberElement.querySelectorAll("input").forEach((el)=>{
          el.removeAttribute("required")
        })
        orderNumberElement.querySelector('input').name = "";
      }
      
    }
  });
});